import React from "react";
import { Dialog } from "primereact/dialog";

const Modal = ({
  visible,
  position,
  onHide,
  dynamicTitle,
  children,
  closable,
  dynamicWidth,
  footer
}) => {
  const width = "50vw";

  const style = {
    width:
      dynamicWidth && typeof dynamicWidth === "string"
        ? dynamicWidth
        : window.innerWidth <= 992
        ? "85vw"
        : dynamicWidth
        ? dynamicWidth
        : width,
  };

  return (
    <Dialog
      header={dynamicTitle} // Use o título dinâmico aqui
      visible={visible}
      closable={closable === undefined ? true : closable}
      position={position}
      footer={footer}
      style={style}
      onHide={onHide}
      draggable={false}
      resizable={false}
    >
      {children}
    </Dialog>
  );
};

export default Modal;
